import { useEffect, useState } from "react";
import "./digiPayPayment.css";
import { editBasket, ShippingAmount } from "../../axios";
import { toast } from "react-toastify";

const DigiPayPayment = () => {
  const [loading, setLoading] = useState(false);
  const [selectedBox, setSelectedBox] = useState(null);
  const [shippingData, setShippingData] = useState({});
  const [fourMaheAmount, setFourMaheAmount] = useState("");
  const [oneMaheAmount, setOneMaheAmount] = useState("");

  const queryParams = new URLSearchParams(location.search);
  const amount = queryParams.get("amount");
  const basketId = queryParams.get("id");

  const handlePayment = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!selectedBox) {
      setLoading(false);
      return toast.error("ابتدا یک گزینه پرداخت انتخاب نمایید");
    }
    if (!amount || !basketId) {
      setLoading(false);
      return toast.error("اطلاعات سبد خرید دریافت نشد");
    }
    const editedAmount =
      selectedBox === "option1" ? oneMaheAmount : fourMaheAmount;
    const { data } = await editBasket(basketId, editedAmount);
    if (data === "1") {
      setLoading(false);
      window.open(
        `https://atropine.ir/DigiPay/Payment.aspx?basketid=${basketId}&amount=${editedAmount}`,
        "_self",
        "noopener,noreferrer,resizable"
      );
    } else {
      setLoading(false);
      return toast.error("ادیت سبد با خطا مواجه شد");
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const { data } = await ShippingAmount();
      if (data) setShippingData(data[0]);
    };

    fetchData();
  }, []);

  console.log("shhipping data" , shippingData);
  

  useEffect(() => {
    if (amount && Number(amount) > 0) {
      if (shippingData) {
        const amount4mahePercentage =
          Number(shippingData?.DigiPay4Mahe) -
          Number(shippingData?.Atropine4Mahe);
        const amount4mahe =
          Number(amount) + (amount / 100) * amount4mahePercentage;
        setFourMaheAmount(amount4mahe);

        const amount1mahePercentage =
          Number(shippingData?.DigiPay1Mahe) -
          Number(shippingData?.Atropine1Mahe);
        const amount1mahe =
          Number(amount) + (amount / 100) * amount1mahePercentage;
        setOneMaheAmount(amount1mahe);
      } else {
        return;
      }
    } else {
      return;
    }
  }, [amount, shippingData]);

  return (
    <div className="digipay-payment">
      <div className="container">
        <div className="row gap-5 align-items-center justify-content-center">
          <div className="col-12 pb-4">
            <p className="fw-bold head-text">
              کاربر گرامی لطفا جهت پرداخت از طریق دیجی پی یکی از روش های زیر را
              انتخاب نمایید و بعد از ورود به درگاه دیجی‌پی نیز گزینه ی مشابه را
              انتخاب کنید.
            </p>
          </div>
          {shippingData ? (
            <>
              <div
                onClick={() => setSelectedBox("option1")}
                className={
                  selectedBox === "option1"
                    ? "col-12 col-md-5 pMethod-box activeBox"
                    : "col-12 col-md-5 pMethod-box "
                }
              >
                <div className="box-header">
                  <h5 className="fw-bold">
                    ۱.پرداخت با <span>اعتبار ماهانه</span> 
                  </h5>
                  <p>
                    کارمزد دیجی‌پی در این حالت <span>{shippingData?.DigiPay1Mahe}%</span> است
                    {Number(shippingData?.Atropine1Mahe) > 0 ? (
                      <p>
                        و از این میزان
                        <span> {shippingData?.Atropine1Mahe}% </span>را آتروپین
                        به عهده گرفته است.
                      </p>
                    ) : null}
                  </p>
                </div>
                <div className="box-footer">
                  قیمت نهایی قابل پرداخت با دیجی پی{" "}
                  {oneMaheAmount.toLocaleString()} ریال
                </div>
              </div>
              <div
                onClick={() => setSelectedBox("option2")}
                className={
                  selectedBox === "option2"
                    ? "col-12 col-md-5 pMethod-box activeBox"
                    : "col-12 col-md-5 pMethod-box "
                }
              >
                <div className="box-header">
                  <h5 className="fw-bold">
                    ۲.پرداخت با <span>اعتبار ۴ قسطه</span> 
                  </h5>
                  <p>
                    کارمزد دیجی‌پی در این حالت <span>{shippingData?.DigiPay4Mahe}%</span> است
                    {Number(shippingData?.Atropine4Mahe) > 0 ? (
                      <p>
                        و از این میزان
                        <span> {shippingData?.Atropine4Mahe}% </span>را آتروپین
                        به عهده گرفته است.
                      </p>
                    ) : null}
                  </p>
                </div>
                <div className="box-footer">
                  قیمت نهایی قابل پرداخت با دیجی پی{" "}
                  {fourMaheAmount.toLocaleString()} ریال
                </div>
              </div>
              <div className="col-12">
                {loading ? (
                  <div
                    className="loader-6 centerLoader"
                    style={{ width: "90%" }}
                  >
                    <span></span>
                  </div>
                ) : (
                  <button onClick={handlePayment}>ادامه پرداخت</button>
                )}
              </div>
            </>
          ) : (
            <p className="text-danger">دیتا از سمت سرور دریافت نشد!</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default DigiPayPayment;
